module.exports = "/img/unitelfutebol-dark.svg?bcd6a01491d3329941e0b65a3a7421f7";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/unitelfutebol-dark.svg
// module id = Fp4i
// module chunks = 60